module.exports = __webpack_public_path__ + "static/media/aurea-key-generator.9615e1cc.mp4";